module.exports = __webpack_public_path__ + "static/media/1.86fee248.JPG";